// Reply/forward quotes (B-21). The original arrives as plain text, so every piece is
// escaped before it goes into the editor's HTML; newlines become <br>.
export function escHtml(s: string): string {
  return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

type Quoted = { fromName?: string | null; fromEmail?: string | null; subject?: string | null; date?: number | null; bodyText?: string | null };

const when = (date?: number | null) => (date ? new Date(date * 1000).toLocaleString() : '');
const text = (s?: string | null) => escHtml(s || '').replace(/\n/g, '<br>');

export function replyQuote(msg: Quoted): string {
  return `<br><br><blockquote style="border-left:2px solid #ccc;padding-left:8px;color:#666">On ${escHtml(when(msg.date))}, ${escHtml(msg.fromName || msg.fromEmail || '')} wrote:<br><br>${text(msg.bodyText)}</blockquote>`;
}

export function forwardQuote(msg: Quoted): string {
  return `<br><br>---------- Forwarded message ----------<br>From: ${escHtml(msg.fromName || '')} &lt;${escHtml(msg.fromEmail || '')}&gt;<br>Date: ${escHtml(when(msg.date))}<br>Subject: ${escHtml(msg.subject || '')}<br><br>${text(msg.bodyText)}`;
}
